import React, { useState, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// Instagram video data
const instagramVideos = [
  {
    id: 1,
    url: "https://www.instagram.com/p/DMiwt3ouyD2/",
    embedUrl: "https://www.instagram.com/p/DMiwt3ouyD2/embed",
    profileName: "@pessoapessoa.adv",
    profileImage: "https://customer-assets.emergentagent.com/job_legal-image-slider/artifacts/d42vkqvu_Design%20sem%20nome%20%284%29.png"
  },
  {
    id: 2,
    url: "https://www.instagram.com/p/DTdqk8mD9Yi/",
    embedUrl: "https://www.instagram.com/p/DTdqk8mD9Yi/embed",
    profileName: "@pessoapessoa.adv",
    profileImage: "https://customer-assets.emergentagent.com/job_legal-image-slider/artifacts/d42vkqvu_Design%20sem%20nome%20%284%29.png"
  },
  {
    id: 3,
    url: "https://www.instagram.com/p/DRmt2D1Dn94/",
    embedUrl: "https://www.instagram.com/p/DRmt2D1Dn94/embed",
    profileName: "@pessoapessoa.adv",
    profileImage: "https://customer-assets.emergentagent.com/job_legal-image-slider/artifacts/d42vkqvu_Design%20sem%20nome%20%284%29.png"
  },
  {
    id: 4,
    url: "https://www.instagram.com/p/DQ-DMvDj4V-/",
    embedUrl: "https://www.instagram.com/p/DQ-DMvDj4V-/embed",
    profileName: "@pessoapessoa.adv",
    profileImage: "https://customer-assets.emergentagent.com/job_legal-image-slider/artifacts/d42vkqvu_Design%20sem%20nome%20%284%29.png"
  },
  {
    id: 5,
    url: "https://www.instagram.com/p/DQcjP8yjhia/",
    embedUrl: "https://www.instagram.com/p/DQcjP8yjhia/embed",
    profileName: "@pessoapessoa.adv",
    profileImage: "https://customer-assets.emergentagent.com/job_legal-image-slider/artifacts/d42vkqvu_Design%20sem%20nome%20%284%29.png"
  }
];

export const ContentSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [dragOffset, setDragOffset] = useState(0);
  const carouselRef = useRef(null);

  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % instagramVideos.length);
  };

  const prevSlide = () => {
    setCurrentIndex(prev => (prev - 1 + instagramVideos.length) % instagramVideos.length);
  };

  // Touch/Mouse drag handlers
  const handleDragStart = (e) => {
    setIsDragging(true);
    const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    setStartX(clientX);
  };

  const handleDragMove = (e) => {
    if (!isDragging) return;
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const diff = clientX - startX;
    setDragOffset(Math.max(-150, Math.min(150, diff)));
  };

  const handleDragEnd = () => {
    if (!isDragging) return;
    setIsDragging(false);
    
    if (dragOffset > 80) {
      prevSlide();
    } else if (dragOffset < -80) {
      nextSlide();
    }
    
    setDragOffset(0);
  };

  // Get indices for display
  const getPrevIndex = () => (currentIndex - 1 + instagramVideos.length) % instagramVideos.length;
  const getNextIndex = () => (currentIndex + 1) % instagramVideos.length;

  return (
    <section className="relative w-full bg-primary py-16 lg:py-24 overflow-hidden" id="conteudos">
      {/* Section Header */}
      <div className="container mx-auto px-4 lg:px-8 mb-12 lg:mb-16">
        <div className="text-center">
          <span className="text-accent font-body text-sm font-medium tracking-[0.2em] uppercase mb-3 block">
            Nosso Conteúdo
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-primary-foreground font-semibold mb-4">
            Conteúdo que orienta você
          </h2>
          <div className="mx-auto w-20 h-0.5 bg-gradient-to-r from-transparent via-accent to-transparent mb-4" />
          <p className="text-primary-foreground/70 font-body text-base lg:text-lg max-w-2xl mx-auto">
            Acompanhe nossos vídeos e fique por dentro dos seus direitos
          </p>
        </div>
      </div>

      {/* Carousel Container */}
      <div className="relative px-4 lg:px-16">
        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-4 lg:left-8 top-1/2 -translate-y-1/2 z-30 p-3 lg:p-4 rounded-full 
                     bg-primary-foreground/10 backdrop-blur-sm border border-primary-foreground/20 
                     text-primary-foreground/80 hover:bg-accent hover:text-primary hover:border-accent
                     transition-all duration-300 hover:scale-110"
          aria-label="Anterior"
        >
          <ChevronLeft className="w-5 h-5 lg:w-6 lg:h-6" />
        </button>

        <button
          onClick={nextSlide}
          className="absolute right-4 lg:right-8 top-1/2 -translate-y-1/2 z-30 p-3 lg:p-4 rounded-full 
                     bg-primary-foreground/10 backdrop-blur-sm border border-primary-foreground/20 
                     text-primary-foreground/80 hover:bg-accent hover:text-primary hover:border-accent
                     transition-all duration-300 hover:scale-110"
          aria-label="Próximo"
        >
          <ChevronRight className="w-5 h-5 lg:w-6 lg:h-6" />
        </button>

        {/* Carousel Track */}
        <div 
          ref={carouselRef}
          className="relative mx-auto max-w-5xl"
          onMouseDown={handleDragStart}
          onMouseMove={handleDragMove}
          onMouseUp={handleDragEnd}
          onMouseLeave={handleDragEnd}
          onTouchStart={handleDragStart}
          onTouchMove={handleDragMove}
          onTouchEnd={handleDragEnd}
          style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
        >
          <div className="flex items-center justify-center gap-6 lg:gap-8 py-4">
            {/* Previous Video (Left) - Hidden on mobile */}
            <div 
              className="hidden lg:block flex-shrink-0 w-[250px] opacity-40 scale-90 transition-all duration-500"
              style={{ transform: `scale(0.9) translateX(${dragOffset * 0.3}px)` }}
            >
              <div className="bg-primary-foreground/5 rounded-2xl overflow-hidden border border-primary-foreground/10 shadow-lg">
                <div className="relative w-full h-[420px] overflow-hidden">
                  <iframe
                    src={instagramVideos[getPrevIndex()].embedUrl}
                    className="absolute top-0 left-0 w-full h-[600px] border-0 pointer-events-none"
                    style={{ marginTop: '-40px' }}
                    loading="lazy"
                    title={`Video anterior`}
                  />
                </div>
              </div>
            </div>

            {/* Current Video (Center) */}
            <div 
              className="flex-shrink-0 w-[300px] lg:w-[340px] z-10 transition-all duration-500"
              style={{ transform: `translateX(${dragOffset * 0.5}px)` }}
            >
              <div className="bg-primary-foreground/5 rounded-2xl overflow-hidden border border-accent/40 shadow-2xl">
                <div className="relative w-full h-[480px] lg:h-[520px] overflow-hidden">
                  <iframe
                    src={instagramVideos[currentIndex].embedUrl}
                    className="absolute top-0 left-0 w-full h-[700px] border-0"
                    style={{ marginTop: '-50px' }}
                    allowFullScreen
                    allow="autoplay; encrypted-media"
                    loading="lazy"
                    title={`Video ${currentIndex + 1}`}
                  />
                </div>
                <div className="p-4 bg-primary/30">
                  <div className="flex items-center justify-between">
                    <span className="text-primary-foreground/70 font-body text-sm">
                      {instagramVideos[currentIndex].profileName}
                    </span>
                    <a 
                      href={instagramVideos[currentIndex].url} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="inline-flex items-center gap-2 text-accent hover:text-accent/80 font-body text-sm font-medium transition-colors group"
                    >
                      Ver no Instagram
                      <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Next Video (Right) - Hidden on mobile */}
            <div 
              className="hidden lg:block flex-shrink-0 w-[250px] opacity-40 scale-90 transition-all duration-500"
              style={{ transform: `scale(0.9) translateX(${dragOffset * 0.3}px)` }}
            >
              <div className="bg-primary-foreground/5 rounded-2xl overflow-hidden border border-primary-foreground/10 shadow-lg">
                <div className="relative w-full h-[420px] overflow-hidden">
                  <iframe
                    src={instagramVideos[getNextIndex()].embedUrl}
                    className="absolute top-0 left-0 w-full h-[600px] border-0 pointer-events-none"
                    style={{ marginTop: '-40px' }}
                    loading="lazy"
                    title={`Próximo video`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Progress indicator */}
        <div className="flex justify-center gap-2 mt-8">
          {instagramVideos.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                index === currentIndex 
                  ? 'w-8 bg-accent' 
                  : 'w-2 bg-primary-foreground/30 hover:bg-primary-foreground/50'
              }`}
              aria-label={`Ir para vídeo ${index + 1}`}
            />
          ))}
        </div>

        {/* Swipe Hint (mobile only) */}
        <div className="lg:hidden text-center mt-6">
          <p className="text-primary-foreground/50 font-body text-xs flex items-center justify-center gap-2">
            <svg className="w-4 h-4 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
            </svg>
            Deslize para ver mais
          </p>
        </div>
      </div>

      {/* Decorative Background */}
      <div className="absolute top-0 left-0 w-1/3 h-full opacity-5 pointer-events-none">
        <div className="absolute top-40 left-20 w-64 h-64 rounded-full bg-primary-foreground blur-3xl" />
        <div className="absolute bottom-40 left-40 w-48 h-48 rounded-full bg-accent blur-2xl" />
      </div>
    </section>
  );
};

export default ContentSection;
